/**
 * Default Header/Footer Config
 * Fallback used whenever no "header-footer" entity has been synced into the
 * local store yet (e.g. first boot before the initial pull/push from Builder),
 * so the site never renders a blank header/footer.
 */

import { HeaderFooterConfig } from './types';

export const DEFAULT_HEADER_FOOTER_CONFIG: HeaderFooterConfig = {
  header: {
    groupLinks: [
      { id: 'gl-1', label: 'New Indian Express', url: 'https://www.newindianexpress.com', openInNewTab: true },
      { id: 'gl-2', label: 'Kannada Prabha', url: 'https://www.kannadaprabha.com', openInNewTab: true },
      { id: 'gl-3', label: 'Cinema Express', url: 'https://www.cinemaexpress.com', openInNewTab: true },
    ],
    socialLinks: [
      { id: 'sl-1', platform: 'Facebook', url: 'https://facebook.com/dinamani' },
      { id: 'sl-2', platform: 'Instagram', url: 'https://instagram.com/dinamani' },
      { id: 'sl-3', platform: 'X', url: 'https://x.com/dinamani' },
      { id: 'sl-4', platform: 'Arattai', url: 'https://arattai.zoho.in/dinamani', iconUrl: '/uploads/thumbnails/arattai-logo.png' },
    ],
    logos: {
      groupLogo: { url: '/uploads/thumbnails/nie-group-logo.png', alt: 'The New Indian Express Group' },
      mainLogo: { url: '/uploads/thumbnails/dinamani-logo.png', alt: 'தினமணி' },
    },
    dateTime: { enabled: true, locale: 'ta', format: 'dd MMMM yyyy, hh:mm a' },
    buttons: [
      { id: 'btn-1', label: 'செய்தி மடல்', url: '/newsletter', style: 'outline', icon: 'https://media.dinamani.com/dinamani/2026-02-27/0o5b196u/crownicon.png' },
      { id: 'btn-2', label: 'இ-பேப்பர்', url: '/epaper', style: 'outline', icon: 'https://media.dinamani.com/dinamani/2026-02-27/36zobb67/papericon.png' },
    ],
  },
  footer: {
    logo: { url: '/uploads/thumbnails/dinamani-logo-white.png', alt: 'தினமணி' },
    tagline: 'தினமணி இணையதளத்தை பின்தொடர',
    socialLinks: [
      { id: 'fsl-1', platform: 'Facebook', url: 'https://facebook.com/dinamani' },
      { id: 'fsl-2', platform: 'WhatsApp', url: 'https://wa.me/919999999999' },
    ],
    appLinks: [
      { id: 'al-1', label: 'App Store', url: 'https://apps.apple.com/app/dinamani' },
      { id: 'al-2', label: 'Google Play', url: 'https://play.google.com/store/apps/details?id=com.dinamani' },
    ],
    quickLinks: [
      { id: 'ql-1', label: 'About Us', url: '/about-us' },
      { id: 'ql-2', label: 'Privacy Policy', url: '/privacy-policy' },
      { id: 'ql-3', label: 'Terms Of Use', url: '/terms-of-use' },
      { id: 'ql-4', label: 'Contact Us', url: '/contact-us' },
    ],
    groups: [
      {
        id: 'fg-1', title: 'About', layout: 'row', columns: 1,
        links: [
          { id: 'l-1', label: 'About Us', url: '/about-us' },
          { id: 'l-2', label: 'Privacy Policy', url: '/privacy-policy' },
          { id: 'l-3', label: 'Terms Of Use', url: '/terms' },
        ],
      },
      {
        id: 'fg-2', title: 'செய்திப் பிரிவுகள்', layout: 'columns', columns: 3,
        links: [
          { id: 'l-4', label: 'முதன்மைச் செய்திகள்', url: '/tamil-nadu' },
          { id: 'l-5', label: 'சிறப்புக் கட்டுரைகள்', url: '/special-articles' },
        ],
      },
      {
        id: 'fg-3', title: 'THE NEW INDIAN EXPRESS GROUP', layout: 'row', columns: 1,
        links: [
          { id: 'l-6', label: 'The New Indian Express', url: 'https://www.newindianexpress.com' },
          { id: 'l-7', label: 'Kannada Prabha', url: 'https://www.kannadaprabha.com' },
        ],
      },
    ],
    recentNews: { enabled: true, title: 'சமீபத்திய செய்திகள்', count: 9, categorySlug: null },
    copyrightText: '©2026 தினமணி மற்றும் அதன் அனைத்து உடைமைகளும் பாதுகாப்பில் உள்ளன.',
  },
};
